<template>
  <section id="promise" class="anchor-section">
    <div class="section-header">
      <a-space align="center">
        <div class="title_icon"></div>
        <div class="ant-descriptions-title section-title">出租方承诺</div>
      </a-space>
    </div>
    <a-card class="plain-content-card">
      <div class="promise-title">
        我方拟对所持有的标的资产通过e指找房不动产租赁平台（以下简称“租赁平台”）进行招租，依照公开、公平、公正和诚实信用原则作如下承诺：
      </div>
      <div class="promise-line">
        （1）本次招租是我方真实意思表示，租赁标的权属清晰，我方有权对外发布招租信息，除已发布的事项外，我方对租赁标的拥有完全的处置权且不存在法律法规禁止或限制招租的情形。
      </div>
      <div class="promise-line">
        （2）本次招租已履行了相应程序，经过有效的内部决策，并获得相应批准。
      </div>
      <div class="promise-line">
        （3）我方所提交的招租信息发布申请及附件材料内容真实、完整、准确、合法、有效，不存在虚假记载、误导性陈述或重大遗漏；我方同意租赁平台按上述材料内容发布招租信息公告（以下简称“招租公告”），并对招租公告内容和上述材料的真实性、完整性、准确性、合法性和有效性承担法律责任。
      </div>
      <div class="promise-line">
        （4）本次招租不设置任何具有明确指向性、歧视性或违反公平竞争原则的招租条件和承租方资格条件；我方完全理解并自愿承担由此引发的全部风险与责任。
      </div>
      <div class="promise-line">
        （5）我方在招租过程中将严格遵守有关法律法规、租赁平台规则及招租公告约定，并按照相关要求履行我方义务。
      </div>
      <div class="promise-line">
        （6）我方在租赁平台招租期间不通过其他渠道进行招租。
      </div>
      <div class="promise-line">
        （7）我方已如实、完整地发布租赁标的状况，并将于本次招租完成后积极协助承租方办理租赁标的交接手续。如因租赁标的交接发生任何争议或纠纷，由我方承担相应责任并自行负责解决。
      </div>
      <div class="promise-line">
        （8）我方将在招租公告发布期间接受并配合意向承租方了解、查勘租赁标的及查阅与之相关的文件。
      </div>
      <div class="promise-line">
        （9）若租赁标的存在优先承租权人的，我方将履行通知义务，包括但不限于通知并要求优先承租权人按招租公告的要求办理参与招租活动相关手续等。
      </div>
      <div class="promise-line">
        （10）在确定承租方后，我方将按照招租公告要求及公开招租结果与承租方签订租赁合同，否则应承担相应法律和经济责任。
      </div>
      <div class="promise-line">
        （11）在本次招租活动、租赁合同签订及履行过程中发生的一切纠纷，均由我方自行解决，与租赁平台无关。
      </div>
      <div class="promise-line">
        （12）我方采用网络竞价（一次报价/多次报价）的竞价方式确定承租方，我方已详细阅读、认可并接受《竞价方案须知》涉及的全部内容。（如涉及）
      </div>
      <div class="promise-line">
        （13）我方承诺将按照招租公告、租赁平台收费指引及服务合同等相关规定与约定，及时足额向租赁平台支付服务费用，不因与承租方发生争议或合同解除、终止等任何事由拒绝、拖延、减少支付或要求退还相关服务费用。
      </div>
      <div class="promise-warning">
        我方保证遵守以上承诺，如违反上述承诺或有违规行为，给本次招租活动的相关方或租赁平台造成损失的，我方愿意承担相应的赔偿责任及其他法律责任。
      </div>
    </a-card>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
.anchor-section {
  scroll-margin-top: 120px;
}

.section-header {
  margin: 30px 4px 14px;
}

.section-title {
  font-size: 16px;
  margin-bottom: 0;
}

.title_icon {
  width: 8px;
  height: 26px;
  margin-right: 10px;
  background: #007aff;
  border-radius: 0 3px 3px 0;
}

.promise-title {
  margin: 4px;
  font-size: 16px;
  font-weight: 700;
}

.promise-line {
  margin: 4px;
  font-size: 14px;
  line-height: 1.9;
}

.promise-warning {
  color: red;
  font-size: 16px;
  margin-top: 6px;
}

.plain-content-card {
  border-radius: 4px;
}
</style>